/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMemberDto } from '../../models/backend-member-dto';

export interface AccessProjectsMembersPartialUpdate$Params {
  mid: number;
  project_id: number;
}

export function accessProjectsMembersPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: AccessProjectsMembersPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMemberDto>> {
  const rb = new RequestBuilder(rootUrl, accessProjectsMembersPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('mid', params.mid, {});
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMemberDto>;
    }),
  );
}

accessProjectsMembersPartialUpdate.PATH = '/api/access/projects/{project_id}/members/{mid}/';
